module.exports = require("path");;